import o from "./ProgressLinear.vue2.mjs";
import { openBlock as r, createElementBlock as l, normalizeClass as s, createElementVNode as t, normalizeStyle as i, renderSlot as n } from "vue";
import "./ProgressLinear.vue3.mjs";
import a from "../../_virtual/_plugin-vue_export-helper.mjs";
const d = { key: 0 }, p = { class: "relative z-10" };
function m(e, c, u, f, v, y) {
  return r(), l("div", {
    class: s(["relative min-h-[0.25rem] overflow-hidden", e.spec.underlayClasses])
  }, [
    e.indeterminate ? (r(), l("div", d, [
      t("div", {
        class: s(["tui-progress-linear-indeterminate--short absolute inset-y-0 left-0", e.spec.progressClasses])
      }, null, 2),
      t("div", {
        class: s(["tui-progress-linear-indeterminate--long absolute inset-y-0 left-0", e.spec.progressClasses])
      }, null, 2)
    ])) : (r(), l("div", {
      key: 1,
      class: s(["absolute inset-y-0 left-0", e.spec.progressClasses]),
      style: i(e.progressStyles)
    }, null, 6)),
    t("div", p, [
      n(e.$slots, "default")
    ])
  ], 2);
}
const $ = /* @__PURE__ */ a(o, [["render", m]]);
export {
  $ as default
};
//# sourceMappingURL=ProgressLinear.vue.mjs.map
